import { reportsServices } from '@/services';

const { generateDataIntegrityReport } = reportsServices;

export default {
  namespaced: true,
  state: () => ({}),
  actions: {
    async generateDataIntegrityReport({ dispatch }, formData) {
      try {
        const response = await generateDataIntegrityReport(formData);

        if (response.status === 202 || response.status === 200) {
          dispatch(
            'notifications/displayNotification',
            {
              message:
                response.data?.message ||
                'Report is being generated. It will be emailed to the data integrity recipient shortly.',
              type: 'success',
            },
            { root: true }
          );
        }

        return response;
      } catch (error) {
        const { message, statusText } = error;
        dispatch(
          'notifications/displayNotification',
          { message: message ? message : statusText, type: 'danger' },
          { root: true }
        );
        throw error;
      }
    },
  },
};
